import {getCabinetDimensions} from "./sqft3dArHelper";
import cabinetWorkspace from "../components/canvas/core/cabinet/cabinetWorkspace";

export const changeShapeLayout = (feature, shape) => {
  const relatedParentFeature = shape.getRelatedParentFeature();
  const dimensions = getCabinetDimensions(feature, relatedParentFeature);
  const lines = getShapeLines(feature, relatedParentFeature);
  const shapeLayout = cabinetWorkspace.cabinetShapes.getShapeLayout(feature, relatedParentFeature);
  shape.shapeParams = {...shape.shapeParams, ...dimensions, shapeLayout}

  shape.changeLines(lines);
}

export const getShapeLines = (feature, relatedParentFeature) => {
  const dimensions = getCabinetDimensions(feature, relatedParentFeature);
  const layout = cabinetWorkspace.cabinetShapes.getShapeLayout(feature, relatedParentFeature)
  return cabinetWorkspace.cabinetShapes.getShapeLines(layout, dimensions);
}
